import React from "react";
import "./_styles.scss";
import { UserPermissions } from "../../../../../src/definitions";
import {  securityService } from "../../../../../src/_global/services";

interface UserCardProps {
  data?: any;
}

export default function UserCard({ data }: UserCardProps) {
  const { first_name, last_name, email_address } = data;
  return (
    securityService.checkRoleAccess(UserPermissions.viewUsers)?
    (
    <div className="user-card">
      <div className="full-name">{`${first_name} ${last_name}`}</div>
      <div className="email-address">{email_address}</div>
    </div>
    ):(<div></div>)
  );
}
